/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import _ from 'lodash'
import { Component } from 'react'
import { Container } from 'flux/utils'
import { withRouter } from 'react-router'
import history from '../../util/history'
import fetchSiteReferrers from '../../action/site_referrer/fetchSiteReferrers'
import AccountTitleDetailAction from '../../action/account_title_detail'
import DailyClosingAction from '../../action/daily_closing'
import ReservationsStore from '../../store/reservation/ReservationsStore'
import DailyClosingDetailsStore from '../../store/daily_closing/DailyClosingDetailsStore'
import DailyClosingReservationsStore from '../../store/daily_closing/DailyClosingReservationsStore'
import DailyClosingHeadStore from '../../store/daily_closing/DailyClosingHeadStore'
import SiteReferrerOptionsStore from '../../store/options/SiteReferrerOptionsStore'
import AccountTitleDetailOptionsStore from '../../store/options/AccountTitleDetailOptionsStore'
import EditViewStore from '../../store/daily_closing/EditViewStore'
import RoomOptionsStore from '../../store/options/RoomOptionsStore'
import DailyProcessEditView from '../../view/pages/daily_process/EditView'
import fetchUserRoomById from '../../action/user/fetchUserRoomById'

class EditContainer extends Component {
  static getStores() {
    return [
      RoomOptionsStore,
      SiteReferrerOptionsStore,
      AccountTitleDetailOptionsStore,
      ReservationsStore,
      DailyClosingHeadStore,
      DailyClosingDetailsStore,
      DailyClosingReservationsStore,
      EditViewStore
    ]
  }

  static calculateState(prevState, props) {
    return {
      site_referrer_options: SiteReferrerOptionsStore.getState(),
      account_title_detail_options: AccountTitleDetailOptionsStore.getState(),
      head: DailyClosingHeadStore.getState(),
      details: DailyClosingDetailsStore.getState(),
      daily_closing_reservations: DailyClosingReservationsStore.getState(),
      view: EditViewStore.getState(),
      ...props
    }
  }

  async componentDidMount() {
    await fetchSiteReferrers('closing')
    await AccountTitleDetailAction.fetchAccountTitleDetails()

    const reservation = _.propertyOf(this.state.location.state)('reservation')

    if (this.isNew()) {
      const close_date = _.propertyOf(this.state.location.state)('close_date')
      const room_id = _.propertyOf(this.state.location.state)('room_id')

      if (!close_date || !room_id) {
        return history.push('/daily')
      }

      await DailyClosingAction.initialize(close_date)
      await fetchUserRoomById(room_id)
      if (reservation) {
        await DailyClosingAction.getTransactionReservation(reservation, this.state.site_referrer_options)
      }
    } else {
      const dailyClosingHeadId = this.state.match.params.id
      await DailyClosingAction.fetchOne(dailyClosingHeadId)
      if (reservation) {
        await DailyClosingAction.addReservation(reservation, this.state.site_referrer_options)
      }
    }
  }

  isNew() {
    return this.state.match.params.id ? false : true
  }

  render() {
    return DailyProcessEditView(this.state)
  }
}

export default withRouter(Container.create(EditContainer, { withProps: true }))
